import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CallingDataService {

  private callingSubject: Subject<any> = new Subject<any>;
  private callingActivitySubject: Subject<any> = new Subject<any>;

  constructor() {
  }

  shareData(data: any): void {
    this.callingSubject.next(data);
  }

  getData(): Observable<any> {
    return this.callingSubject.asObservable();
  }

  shareActivityData(data: any, activity: any): void {
    data['activity'] = activity;
    this.callingActivitySubject.next(data);
  }

  getActivityData(): Observable<any> {
    return this.callingActivitySubject.asObservable();
  }

  shareIncomingCallResponseData(data: any): void {
    this.callingActivitySubject.next(data);
  }

  getIncomingCallData(): Observable<any> {
    return this.callingActivitySubject.asObservable();
  }

}
